import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginActions } from './action/loginAction';
import { withTranslation } from 'react-i18next';
import { appVariables } from './helpers/appVariables';
import { alertActions } from './action/AlertAction';
import Header from './Header/Header';
// import countrycode from './Pages/Home/countrycode.json';
import { history } from './helpers/history';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { commonClass } from './helpers/commonClass';

class ForgotPasswordOtpNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: ['', '', '', '', '', ''],
            newPwd: "",
            ConfirmPwd: "",
            shownewpwd: false,
            showconfrimpwd: false,
            myRTime: 0,
            timeFinished: false,
            myRefNo: 0,
            ShowErrorMsg: ""
        }
        this.handleChange = this.handleChange.bind()
    }
    handleChange = (e) => {
        try { this.setState({ [e.target.name]: e.target.value }); }
        catch (ex) { }
    }
    static getDerivedStateFromProps(props, state) {
        return { otp: props.otp };
    };
    showMsg = (msg) => {
        this.props.alertError(this.props.t(msg));
    }
    handleInputChange = (value, e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState(prevState => ({ list: prevState.list.map((obj, inx) => (inx === value ? e.target.value : obj)) }));
            if (((this.state.list.length - 1) > value) || e.target.value == "") {
                let Check = `input[name='${e.target.value !== "" ? (parseInt(value) + 1) : ((value !== 0) ? parseInt(value) - 1 : parseInt(value))}']`;
                document.querySelector(`input[name='${e.target.value !== "" ? (parseInt(value) + 1) : ((value !== 0) ? parseInt(value) - 1 : parseInt(value))}']`).focus();
                // document.querySelector(`input[name=2`).focus()
            }
        }
    }


    ResendOtp = () => {
        if (this.props.otp.mobileNo && this.props.otp.mobileNo != "") {
            if (this.state.timeFinished == false) {
                // this.props.alertError(this.props.t("Try after OTP expired"));                
                return;
            }
            if (this.props.otp.flog == 3) {
                this.props.Otpgen(this.props.otp.mobileNo, appVariables.OTP.ForgetPassword, this.props.i18n.language, this.props.user.loginKey, this.state.otp.Ccode)
            }
        }
    }

    componentDidMount(prevState, prevProps) {
        setTimeout(() => {
            if (window.LoginOverlay) {
                window.LoginOverlay()
            }
        }, 300);
    }
    componentDidUpdate(previousProps, previousState) {
        if (this.props.otp && this.props.otp.ExpSec && this.props.otp.ExpSec > 0) {
            if (this.state.myRefNo != this.props.otp.RefNo) {//to check new otp after click resend btn
                this.state.myRefNo = this.props.otp.RefNo;
                this.state.myRTime = 0;
                this.state.timeFinished = false;
            }
            if (this.state.timeFinished == true) //check the time completed
            {
                return;
            }
            let tot = 0
            if (this.state.myRTime > 0) {
                tot = this.state.myRTime;
            }
            else {
                tot = this.props.serverTime + (this.props.otp.ExpSec * 1000);
                this.state.myRTime = tot;
            }
            let _rtime = tot - this.props.serverTime;
            let second = 1000
            let minute = second * 60
            let hour = minute * 60
            let day = hour * 24
            let _mintime = Math.floor(_rtime % day % hour / minute);
            let _sectime = Math.floor(_rtime % day % hour % minute / second);
            this.state.Rtime = _mintime + " : " + _sectime;
            if (_mintime <= 0 && _sectime <= 0) {
                this.state.Rtime = "";
                this.state.timeFinished = true;
            }
        }
    }

    VerifyOtp = (e) => {
        e.preventDefault();
        let _otp = this.state.list.join('');
        if (_otp.length === 6) {
            this.props.VerifyOtpForgotPass(this.props.otp.mobileNo, _otp, this.props.i18n.language, this.props.user.loginKey, this.state.otp.Ccode, appVariables.OTP.ForgetPassword, this.state.otp)
        }
        else { this.showMsg('lblEnterValidOtp'); return; }
    }

    render() {
        const { t } = this.props;
        let IsError = this.state.ShowErrorMsg.length > 0;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket - Login</title>
                    <meta name="description" content="Securely Access Your Gulf Ticket Account: Login Now" />
                    <meta name="keywords" content="Gulf Ticket, online raffle draw, Biggest Online Draw" />

                    <meta property="og:title" content="Gulf Ticket - Login" />
                    <meta property="og:site_name" content="Gulf Ticket" />
                    <meta property="og:url" content="https://gulfticket.com" />
                    <meta property="og:description" content="Securely Access Your Gulf Ticket Account: Login Now" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                </Helmet>}
                <div class="signInBox" style={{ display: "block" }}>
                    <div class="signInBoxWrap">
                        <div class="signBoxLft">
                            <img src="./assets/img/sign-lft.png" />
                        </div>
                        <div class="signBoxRht">
                            <div class="userContent">
                                <a class="lightBoxClose" ><img src="./assets/img/icons/pop_close.png" /></a>
                                <h1>{t('lblOTP')}</h1>
                                <p>{t('lblSendSixDigitCode')}{" "}
                                    <span dir='ltr'>{this.props.otp && this.props.otp.Ccode} {this.props.otp.mobileNo.substring(0, 3)}*****{this.props.otp.mobileNo.substring(this.props.otp.mobileNo.length - 2, this.props.otp.mobileNo.length)}</span>
                                    {" "} {t('lblVlaidateNo')}.</p>
                                <p>{this.props.otp && this.props.otp.otp}</p>
                                <form class="register-form paddTop-20" onSubmit={this.VerifyOtp}>
                                    <div class="formCont">
                                        <label>{t('lblOTP')} {t('lblCode')}</label>
                                        <div class="userLogContOtp userLogCont2 ">
                                            {this.state.list.map((digit, idx) => (
                                                <input autoFocus={idx === 0} key={idx} name={idx} type="text" inputMode="numeric" autoComplete="one-time-code" pattern="\d{1}" maxLength={1} className="otpInput" value={digit.value} onKeyUp={this.handleInputChange.bind(this, idx)} />
                                            ))}
                                        </div>
                                    </div>
                                    <div className="reSendBtn rtl:flex"><p>{t('lblDidnotReceiveSMS')}</p> <a onClick={() => this.ResendOtp()} style={{ color: (this.state.timeFinished ? "#494949" : "#878585") }}>{t('lblResend')}</a>
                                        <div >{this.state.Rtime ? this.state.Rtime + "s" : ""}</div>
                                    </div>
                                    <div class="formCont">
                                        <button class="margin-0" >{t('lblVerify')}</button>
                                    </div>
                                </form>
                                <span class="agree"><a onClick={() => { this.props.getflag(0) }} target="_blank">{t('lblback')} {t('lblLogin')}</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overlayLogin" style={{ display: "block" }}></div>
            </>
        );
    }
}
function mapStateToProps(state) {
    const { serverTime } = state.commonReducer;
    const { user, otp, appvariables } = state.loginReducer;
    return { user, otp, appvariables, serverTime };
}
const mapActionToProps = {
    login: loginActions.login,
    setPage: loginActions.setPage,
    Otpgen: loginActions.lfnotpgen,
    alertError: alertActions.error,
    logout: loginActions.logout,
    VerifyOtpForgotPass: loginActions.VerifyOtpForgotPass
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(ForgotPasswordOtpNew))